'use client';

import React, { useState } from 'react';
import RowPricingGrid from '../../components/Estimator/EditPricing/RowPricingGrid';
import PipePricingGrid from '../../components/Estimator/EditPricing/PipePricingGrid';
import CoatingPricingGrid from '../../components/Estimator/EditPricing/CoatingPricingGrid';
import ConstructionPricingGrid from '../../components/Estimator/EditPricing/ConstructionPricingGrid';
import ComponentPricingGrid from '../../components/Estimator/EditPricing/ComponentPricingGrid';
import MiscPricingGrid from '../../components/Estimator/EditPricing/MiscPricingGrid';
import LineFillPricingGrid from '../../components/Estimator/EditPricing/LineFillPricing';
import { Box, Tabs, Tab, Typography } from '@mui/material';

const TabPanel = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const EditPricing = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tabIndex}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .MuiTab-root': {
            minWidth: '180px',
            fontSize: '16px',
            padding: '12px 20px',
            textTransform: 'none',
          },
          '& .MuiTabs-indicator': {
            height: '4px',
            borderRadius: '2px',
          },
        }}
      >
        <Tab label="ROW Pricing" />
        <Tab label="Pipe Pricing" />
        <Tab label="Coating Pricing" />
        <Tab label="Construction Pricing" />
        <Tab label="Component Costs" />
        <Tab label="Misc Cost" />
        <Tab label="Line Fill Cost" />
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        <RowPricingGrid />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <PipePricingGrid />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <CoatingPricingGrid />
      </TabPanel>
      <TabPanel value={tabIndex} index={3}>
        <ConstructionPricingGrid />
      </TabPanel>
      <TabPanel value={tabIndex} index={4}>
        <ComponentPricingGrid />
      </TabPanel>
      <TabPanel value={tabIndex} index={5}>
        <MiscPricingGrid />
      </TabPanel>
      <TabPanel value={tabIndex} index={6}>
        <LineFillPricingGrid />
      </TabPanel>
    </Box>
  );
};

export default EditPricing;
